export class Caja {
  id: number;
  name: string;
  initialBalance: number;
  currentBalance: number;
  salesPointId: number;
  cashBox: any;
  salesPoint: any;
  uid: string;
  receiptBookId: number;
  receiptBook: any;
}
